// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2L8nO","actionsCol":"EnrolledClinics_actionsCol__2WBuH"};